/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setTemplates, selectTemplateCount } from '../redux/reducers/templateSlice';
import { IconWithBackground } from "@/subframe/components/IconWithBackground";
import { Badge } from "@/subframe/components/Badge";
import { Accordion } from "@/subframe/components/Accordion";
import TemplateList from '../components/templates/TemplateList';
import TemplateMessageSend from './templates/TemplateMessageSend';
import { addEsChatToConfig } from '../Utils/apiUtils';
import axios from 'axios';

function Templates({ currentRecipient }: any) {
  const dispatch = useDispatch();
  const templateCount = useSelector(selectTemplateCount);
  // const variables = useSelector(selectTemplateVariables);

  const fetchTemplates = useCallback(async () => {
    try {
      const config = addEsChatToConfig();
      
      const response = await axios.get('https://api.insightssystem.com/api:bVXsw_FD/web/templates', config);
      dispatch(setTemplates(response.data));
    } catch (error) {
    }
  }, [dispatch]);

  useEffect(() => {
    fetchTemplates();
  }, [fetchTemplates]);

  // const handleVariableChange = (key: string, value: string) => {
  //   dispatch(updateTemplateVariable({ key, value }));
  // };

  return (
    <div className="flex w-full flex-col items-start rounded-md bg-neutral-50">
      <Accordion
        trigger={
          <div className="flex w-full items-center gap-4 pl-6 pr-10 py-2.5">
            <IconWithBackground size="medium" icon="FeatherLayoutTemplate" square={true} />
            <span className="grow shrink-0 basis-0 text-heading-3 font-heading-3 text-default-font">
              Templates
            </span>
            <Badge variant="neutral">{templateCount}</Badge>
            <Accordion.Chevron />
          </div>
        }
      >
        <div className="conveythis-no-translate flex flex-col w-full relative">
          <div className="w-full h-[500px] overflow-auto custom-scrollbar">
            <TemplateList />
          </div>
          <TemplateMessageSend currentRecipient={currentRecipient} />
        </div>
      </Accordion>
    </div>
  );
}

export default Templates;